import monitorRamaisHttpService from '../_services/monitorRamaisHttpService'
import {
  SOCKET_Endpoint,
  SOCKET_NewPeerState,
  SOCKET_PJSIPChannel,
  PREV_CALL_INDEX,
  PREV_CALL_INDEX_OPERADOR,
  NEXT_CALL_INDEX,
  NEXT_CALL_INDEX_OPERADOR,
  RESET_CALL_INDEX,
  SOCKET_updateEndpoint,
  SOCKET_DeleteEndpoint,
  SOCKET_NewAgent,
  SOCKET_UpdateAgentStatus,
  SOCKET_RemoveAgent,
  SOCKET_NewQueueCall,
  SOCKET_CallOnWait,
  SOCKET_RemoveCallOnWait,
  SOCKET_callsMonitorOperador,
  SOCKET_ProtocolNew,
  SOCKET_ProtocolOld,
  SOCKET_ClickToCall,
  SOCKET_Hangup,
  SOCKET_LinkedIdEnd,
  SOCKET_Connect,
  SOCKET_FullyBooted,
  SOCKET_HistoryOld,
  SOCKET_HistoryNew,
  SOCKET_EndListAgent,
  GET_ALL_PEERS,

  SOCKET_NewQueueCallOnConnect,
  SOCKET_CallOnWaitOnConnect,
  SOCKET_UpdateAgentStatusOnConnect,
  SOCKET_NewAgentOnConnect,
  SOCKET_PJSIPChannelOnConnect,
  SOCKET_EndpointOnConnect,
} from './mutation-types'

export default {
  SOCKET_FullyBooted: ({ commit }) => {
    commit(SOCKET_FullyBooted)
  },
  SOCKET_Connect: ({ commit }) => {
    commit(SOCKET_Connect)
  },

  SOCKET_Endpoint: ({ commit }, data) => {
    try {
      commit(SOCKET_Endpoint, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_PJSIPChannel: ({ commit }, data) => {
    try {
      commit(SOCKET_PJSIPChannel, data)
      if (data.status === 'UP') {
        commit(SOCKET_RemoveCallOnWait, data)
      }
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_ClickToCall: async ({ commit }, data) => {
    try {
      commit(SOCKET_ClickToCall, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_NewPeerState: ({ commit }, data) => {
    try {
      commit(SOCKET_NewPeerState, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_newEndpoint: ({ commit }, data) => {
    try {
      commit(SOCKET_Endpoint, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_updateEndpoint: ({ commit }, data) => {
    try {
      commit(SOCKET_updateEndpoint, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_DeleteEndpoint: ({ commit }, data) => {
    try {
      commit(SOCKET_DeleteEndpoint, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_NewAgent: async ({ commit }, data) => {
    try {
      commit(SOCKET_NewAgent, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_RemoveAgent: ({ commit }, data) => {
    try {
      commit(SOCKET_RemoveAgent, data)
    } catch (e) {
      console.log(e)
    }
  },
 
  

  SOCKET_Hangup: ({ commit }, data) => {
    try {
      commit(SOCKET_Hangup, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_LinkedIdEnd: ({ commit }, data) => {
    try {
      commit(SOCKET_LinkedIdEnd, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_UpdateAgentStatus: async ({ commit }, data) => {
    try {
      commit(SOCKET_UpdateAgentStatus, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_NewQueueCall: async ({ commit }, data) => {
    try {
      commit(SOCKET_NewQueueCall, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_HistoryOld: async ({ commit }, data) => {
    try {
      commit(SOCKET_HistoryOld, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_HistoryNew: async ({ commit }, data) => {
    try {
      commit(SOCKET_HistoryNew, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_CallOnWait: async ({ commit }, data) => {
    try {
      commit(SOCKET_CallOnWait, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_RemoveCallOnWait: async ({ commit }, data) => {
    try {
      commit(SOCKET_RemoveCallOnWait, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_callsMonitorOperador: ({ commit }, data) => {
    try {
        commit(SOCKET_callsMonitorOperador, JSON.parse(data))
        // console.log(data, "data")
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_ProtocolNew: ({ commit }, data) => {
    try {
        commit(SOCKET_ProtocolNew, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_ProtocolOld: ({ commit }, data) => {
    try {
        commit(SOCKET_ProtocolOld, data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_EndListAgent: ({ commit }, data) => {
    try {
        commit(SOCKET_EndListAgent, data)
    } catch (e) {
      console.log(e)
    }
  },


  prevCall: ({ commit }, deviceId) => {
    try {
      commit(PREV_CALL_INDEX, deviceId)
    } catch (e) {
      console.log(e)
    }
  },

  nextCall: ({ commit }, deviceId) => {
    try {
      commit(NEXT_CALL_INDEX, deviceId)
    } catch (e) {
      console.log(e)
    }
  },

  prevCallOperador: ({ commit }, deviceId) => {
    try {
      commit(PREV_CALL_INDEX_OPERADOR, deviceId)
    } catch (e) {
      console.log(e)
    }
  },

  nextCallOperador: ({ commit }, deviceId) => {
    try {
      commit(NEXT_CALL_INDEX_OPERADOR, deviceId)
    } catch (e) {
      console.log(e)
    }
  },

  resetCall: ({ commit }, deviceId) => {
    try {
      commit(RESET_CALL_INDEX, deviceId)
    } catch (e) {
      console.log(e)
    }
  },

  listarRamaisDaApi: async ({ commit }) => {
    try {
      const response = await monitorRamaisHttpService.getRamaisLazy()
      commit(GET_ALL_PEERS, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  SOCKET_NewQueueCallOnConnect: async ({ commit }, data) => {
    try {
      commit(SOCKET_NewQueueCallOnConnect, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_CallOnWaitOnConnect: async ({ commit }, data) => {
    try {
      commit(SOCKET_CallOnWaitOnConnect, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_UpdateAgentStatusOnConnect: async ({ commit }, data) => {
    try {
      commit(SOCKET_UpdateAgentStatusOnConnect, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_NewAgentOnConnect: async ({ commit }, data) => {
    try {
      commit(SOCKET_NewAgentOnConnect, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_PJSIPChannelOnConnect: async ({ commit }, data) => {
    try {
      commit(SOCKET_PJSIPChannelOnConnect, data)
    } catch (e) {
      console.log(e)
    }
  },
  SOCKET_EndpointOnConnect: async ({ commit }, data) => {
    try {
      commit(SOCKET_EndpointOnConnect, data)
    } catch (e) {
      console.log(e)
    }
  },


}
